var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"text-h4 font-weight-bold",domProps:{"textContent":_vm._s(_vm.t$.title)}}),_c('HTMLRender',{staticClass:"mt-3 text-paragraph-2",attrs:{"locale":"sites.form.fields.domainHint.subtitle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }